/**
 * MAC STANDARD WORKBENCH CONFIGURATOR — PRICING DATA
 * ---------------------------------------------------------------
 * EDIT PRICES HERE. All prices are INC VAT, in pounds.
 *
 * prices: "LENGTH x DEPTH" (mm)  ->  top thickness (mm)  ->  price
 *   e.g. "1200 x 800": { "6": 595, "8": 630, "10": 675 }
 *   means a 1200 x 800mm bench with a 6mm top is £595 inc VAT.
 *
 * castorPrice: added to the bench price when castors are chosen.
 * Colours are powder coated at no extra charge.
 *
 * The cart line uses a £0 Shopify variant (one per size and top,
 * product "MAC Standard Workbench") so the right weight goes to
 * shipping; the price below is applied in the cart via __price,
 * the same way as the table configurators.
 * Draft prices, 23 Oct 2026.
 * ---------------------------------------------------------------
 */
window.WORKBENCH_CONFIGURATOR_DATA = {
  currency: "£",
  vatRate: 0.20,
  worktopHeight: 900,
  castorHeight: 184,
  /* Castor spec from Jack 24 Oct 2026. Worktop stays at worktopHeight: legs are cut down by castorHeight. */
  castorSpec: { wheel: 150, height: 184, ratingEach: 150, count: 4, layout: "2 fixed + 2 swivel with brake" },
  castorPrice: 120, /* heavy duty castors, inc VAT (was 80), Jack 24 Oct 2026 */

  lengths: [1000, 1200, 1500, 1800, 2000, 2400],
  depths: [800, 1000, 1200],
  tops: [6, 8, 10],

  colours: ["Red", "Green", "Blue", "Grey", "Black"],

  prices: {
    "1000 x 800": { "6": 550, "8": 580, "10": 620 },
    "1000 x 1000": { "6": 590, "8": 630, "10": 675 },
    "1000 x 1200": { "6": 640, "8": 685, "10": 735 },
    "1200 x 800": { "6": 595, "8": 630, "10": 675 },
    "1200 x 1000": { "6": 640, "8": 685, "10": 735 },
    "1200 x 1200": { "6": 690, "8": 745, "10": 805 },
    "1500 x 800": { "6": 650, "8": 695, "10": 745 },
    "1500 x 1000": { "6": 700, "8": 755, "10": 820 },
    "1500 x 1200": { "6": 760, "8": 825, "10": 900 },
    "1800 x 800": { "6": 715, "8": 765, "10": 830 },
    "1800 x 1000": { "6": 770, "8": 835, "10": 910 },
    "1800 x 1200": { "6": 835, "8": 915, "10": 1000 },
    "2000 x 800": { "6": 750, "8": 810, "10": 875 },
    "2000 x 1000": { "6": 810, "8": 885, "10": 965 },
    "2000 x 1200": { "6": 880, "8": 970, "10": 1065 },
    "2400 x 800": { "6": 840, "8": 910, "10": 990 },
    "2400 x 1000": { "6": 910, "8": 995, "10": 1090 },
    "2400 x 1200": { "6": 985, "8": 1090, "10": 1205 }
  },

  /* BOTTOM BRACE
     HI = H/I brace (end rails joined by one centre rail), standard on fixed legs.
     AR = all-round brace. Included in the castor price and locked on with castors.
     fixedAllRoundPrice: confirmed by Jack 24 Oct 2026, same cost as H/I, so no extra charge. */
  brace: { fixedAllRoundPrice: 0 },

  /* BACK UPSTAND: one height, 200mm, 4mm sheet, along the back edge.
     Prices approved by Jack 24 Oct 2026 (Max's FlatQuote run, old 4mm price, sell = cost x 2).
     priceExVat by bench LENGTH (mm), depth makes no difference. These are EX VAT; the
     configurator adds VAT (vatRate) because every other price in this file is INC VAT. */
  upstand: { height: 200, thickness: 4, priceExVat: { "1000": 55.84, "1200": 62.16, "1500": 63.26, "1800": 96.04, "2000": 97.04, "2400": 109.72 } },

  /* LOGO cut out of the upstand only (free).
     Confirmed by Jack 24 Oct 2026: any size, kept at least 20mm from every upstand edge (top, bottom, ends) and clear of the corner radius/chamfer. No width cap. */
  logo: { margin: 20, uploadReady: false /* Upload-Lift not approved: upload stubbed */ },

  /* VICE / ACCESSORY HOLES (free). margin 25mm: confirmed by Jack, measured from the worktop edge to the HOLE EDGE (centre limit = 25 + diameter/2). Shown as dashed keep-out line. */
  /* holes: default pattern "3" (triangle: 2 towards the front pitchX apart, 1 centre hole pitchY towards the back), "2", "4" or "custom". */
  vice: { margin: 25, snap: 5, holes: "3", pitchX: 160, pitchY: 120, dia: 14 },

  /* Quote PDF terms approved as written by Jack 24 Oct 2026. */
  quote: { validDays: 7, phone: "01432 381 233", email: "sales@macindustries.co.uk" },

  productHandle: "standard-workbench-configurator",
  skuPrefix: "WB"
};
